import React, { useLayoutEffect, useState } from 'react';
import { Badge, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { getVideoCountByCategory } from '../../../api/video';
import { useAuth } from '../../../contexts/auth';
import { useMenuContext } from '../../../contexts/menuContextProvider';

const VideoKategoria = ({
  kategoriaNev,
  katKey,
  katDescr,
  cldImageName,
  onKatClick,
}) => {
  const navigate = useNavigate();
  const { setMenu } = useMenuContext();
  const [openVideos, setOpenVideos] = useState(0);
  const { user } = useAuth();
  let hasUserRights = false;
  let button_text = 'Belépek ...';

  if (user && user.activeSubscriptions?.length !== 0) {
    hasUserRights = true;
    button_text = 'Megnézem ...';
  } else if (!user) {
    hasUserRights = true;
    button_text = 'Belépek ...';
  }

  const onDetailsClick = () => {
    setMenu({ type: 'cat', key: katKey, title: kategoriaNev });
    navigate(user ? '/videos' : '/login');
  };

  useLayoutEffect(() => {
    if (user && localStorage.token) {
      getVideoCountByCategory(katKey, new Date('2020.01.01'))
        .then((d) => {
          setOpenVideos(d.data.videoCount);
        })
        .catch(() => setOpenVideos(0));
    } else {
      setOpenVideos(0);
    }
  }, [user, katKey]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: 290,
          height: 250,
          padding: 2,
          border: '1px solid #ccc',
          borderRadius: '20px',
          boxShadow: '0 0 8px rgba(0, 0, 0, 0.3)',
          transition: 'all 0.3s ease-in-out',
          backgroundSize: 'cover',
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/${cldImageName}.jpg)`,
          marginTop: 1,
          marginRight: 1,
          position: 'relative',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
          },
        }}
        onClick={onKatClick || onDetailsClick}
      >
        {/* BADGE külön, pozícionálva */}
        <Badge
          badgeContent={hasUserRights && openVideos !== 0 ? openVideos : 0}
          color='error'
          invisible={!hasUserRights || openVideos === 0}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            '& .MuiBadge-badge': {
              fontSize: '0.8rem',
              minWidth: 24,
              height: 24,
              borderRadius: '50%',
              border: '2px solid white',
              boxShadow: '1px 1px 1px black',
            },
          }}
        />

        {/* Középen maradó cím */}
        <Typography
          variant='h6'
          sx={{
            fontSize: '1.8rem',
            fontWeight: 600,
            color: 'white',
            textShadow: '0px 0px 20px rgb(187, 150, 107)',
            position: 'absolute',
            top: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            textAlign: 'center',
          }}
        >
          {kategoriaNev}
        </Typography>
      </Box>

      <Box sx={{ flex: 4 }}>
        {katDescr && <Typography>{katDescr}</Typography>}
      </Box>
    </Box>
  );
};

export default VideoKategoria;
